export interface ITiposDocumentoData {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: ITipoDocumento[];
}

export interface ITipoDocumento {
  id_tipo_documento: string;
  nombre: string;
}

export enum TipoDocumentoNameEnum {
  PASAPORTE = "PASAPORTE",
  RUC = "RUC",
  CEDULA = "CÉDULA",
}

export enum EstadoContribuyenteRucENUM {
  SUSPENDIDO = "SUSPENDIDO",
  ACTIVO = "ACTIVO",
}

export enum NacionalidadEnum {
  ECUATORIANA = "ECUATORIANA",
  ECUADOR = "ECUADOR",
  CODIGO = "EC",
}
export enum CondicionCeduladoEnum {
  CIUDADANO = "CIUDADANO",
  EXTRANJERO = "EXTRANJERO",
  PERMANENTE = "PERMANENTE",
  DISCAPACIDAD = "DISCAPACIDAD",
  DISCAPACITADO = "DISCAPACITADO",
  TEMPORAL = "TEMPORAL",
  INTERDICTO = "INTERDICTO",
  VISADO = "VISADO",
  PERDIDA_DE_DERECHOS = "PERDIDA DE DERECHOS",
}

export interface ICreateDocumentTypeResponseData {
  id_tipo_documento: number;
  nombre: string;
}

export interface IRemoveDocumentTypeResponseData {
  code: number;
  status: string;
  message: string;
  data: null;
}
